import { tick } from './haptic'
import './picked.css'

// Picked choices (Liam, 3 Nov 2026: "C improved"; picked.css). When a tap or click newly picks a choice, it gets the
// app's press and its one tick once, plus one light buzz on a phone; unpicking, redraws and opening a screen play
// nothing. A later tap cancels an earlier one's movement, so fast taps always land on the last.
const CHOICES = [
  '.booking-day', '.often-num', '.often-kind', '.fj-day', '.fj-choice', '.price-sheet-chip', '.who-out-name',
  '.they-replied-day', '.day-close-chip', '.day-close-grid > .btn-secondary', '.day-total-chip', '.team-days-sort',
  '.customer-offer-when button', '.other-jobs-choices button.link-button', '.invoices-download-picks button',
  '.reply-date-shortcuts button', '.diary-move-dates button', '.ask-ahead-switch button', '.mb-pay-kinds button',
  '.booking-chip', '.close-out-chip', '.parking-chip', '.offer-extra-pill', '.diary-notdone-reason', '.owner-pay-tile',
  '.owner-pay-chip', '.wd-extra-tile', '.offer-agreement-option', '.messages-date-button',
].join(', ')

const picked = (el: Element): boolean => el.getAttribute('aria-pressed') === 'true' || el.classList.contains('is-on')
let last: HTMLElement | null = null

export function startPickedChips(): void {
  document.addEventListener('click', (event) => {
    const chip = (event.target as Element | null)?.closest?.<HTMLElement>(CHOICES)
    if (!chip || (event as MouseEvent).button > 0) return
    const was = picked(chip)
    // After the screen's own handler has run (and perhaps drawn the chip again).
    requestAnimationFrame(() => {
      const now = chip.isConnected ? chip : null
      if (!now || !picked(now) || was) return
      last?.classList.remove('pick-anim')
      void now.offsetWidth
      now.classList.add('pick-anim'); last = now
      window.setTimeout(() => { now.classList.remove('pick-anim'); if (last === now) last = null }, 260)
      tick()
    })
  })
}
